<template>
    <ul class="w-full">
        <li v-for="(cylinder, index) in cylinders" :key="index" class="flex flex-wrap">
            <!-- Maat -->
            <div :class="hidePrices ? 'w-fit' : 'w-2/3'">
                <span v-if="cylinder.name">{{ cylinder.name }}:</span>
                <span v-else>Cilinder {{ index + 1 }}:</span>

                <!-- Qty -->
                <span class="" v-if="cylinder.qty && cylinder.qty != 0"> ({{ cylinder.qty }}x)</span>
                <span v-if="cylinder.qty == 0" class="ml-3 italic">Gereserveerd</span>
                <span v-else-if="cylinder.type && cylinder.type.id && cylinder.type.id > 1" class="ml-3 font-semibold">
                    {{ cylinder.type.id == 2 ? 'Oplegslot' : 'Hangslot' }}
                </span>
                <span v-else class="ml-3 font-semibold">{{ cylinder.a == 0 ? '--' : cylinder.a }}/{{ cylinder.b == 0 ? '--' : cylinder.b }}</span>
            </div>

            <div class="w-1/3 text-right" v-if="!hidePrices">
                <span v-if="totals && index in totals.cylinders && totals.cylinders[index] && cylinder.a && cylinder.b">
                    {{ price(totals.cylinders[index].cylinder_price) }}
                </span>
                <span v-else> - </span>
            </div>

            <!-- Kleur -->
            <div  :class="hidePrices ? 'w-fit pl-2' : 'flex flex-wrap w-full'" v-if="totals && totals.cylinders[index] && totals.cylinders[index].color > 0">
                <div :class="hidePrices ? 'w-fit' : 'w-2/3 pl-4'">+ {{ cylinder.color.value }}</div>
                <div class="w-1/3 text-right" v-if="!hidePrices">
                    <span>
                        {{ price(totals.cylinders[index].color) }}
                    </span>
                </div>
            </div>

            <!-- Knop -->
            <div :class="hidePrices ? 'w-fit pl-2' : 'flex flex-wrap w-full'" v-if="totals && totals.cylinders[index] && totals.cylinders[index].button > 0 && cylinder.button.value">
                <div :class="hidePrices ? 'w-fit' : 'w-2/3 pl-4'">+ {{ cylinder.button.value }}</div>
                <div class="w-1/3 text-right" v-if="!hidePrices">
                    <span>
                        {{ price(totals.cylinders[index].button) }}
                    </span>
                </div>
            </div>

            <!-- Paniekfunctie -->
            <div class="flex flex-wrap w-full" v-if="totals && totals.cylinders[index] && totals.cylinders[index].panic_function > 0 && cylinder.panic_function.value">
                <div :class="hidePrices ? 'w-fit' : 'w-2/3 pl-4'">+ {{ cylinder.panic_function.value == 'Nee' ? 'Zonder paniekfunctie' : 'Met paniekfunctie' }}</div>
                <div class="w-1/3 text-right" v-if="!hidePrices">
                    <span>
                        {{ price(totals.cylinders[index].panic_function) }}
                    </span>
                </div>
            </div>

            <!-- type -->
            <!-- <div class="flex flex-wrap w-full" v-if="cylinder.type && cylinder.type.id && cylinder.type.id > 1">
                <div :class="hidePrices ? 'w-fit' : 'w-2/3 pl-4'">+ {{ cylinder.type.name }}</div>
                <div class="w-1/3 text-right" v-if="!hidePrices">
                    <span>
                        {{ price(totals.cylinders[index].type.price) }}
                    </span>
                </div>
            </div> -->
        </li>

        <!-- Keys -->
        <li v-if="totals && totals.key_price && keys" class="flex flex-wrap">
            <div class="w-2/3 flex items-center">
                Sleutels:
                <span class="mx-1">
                    {{ totals.default_key_qty > keys.qty ? totals.default_key_qty : keys.qty > 0 ? keys.qty : totals.default_key_qty }}
                </span>
                <span v-if="totals.key_price > 0 && keys.default > 0">({{ keys.qty - totals.default_key_qty }} extra)</span>
            </div>

            <div class="w-1/3 text-right" v-if="!hidePrices && totals.key_price > 0 && keys.default > 0">
                <span>
                    {{ price(totals.key_price) }}
                </span>
            </div>
            <ul class="w-full" v-if="keys.colors && keys.colors.length">
                <li v-for="color in keys.colors">
                    <div class="pl-2" v-if="color.qty > 0">- {{ color.name }}: {{ color.qty }}</div>
                </li>
            </ul>
        </li>

        <li class="flex flex-wrap" v-for="(option, index) in options" :key="index">
            <div class="w-2/3">{{ option.attribute }}: {{ option.value }}</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">{{ price(option.price) }}</div>
        </li>

        <!-- Padlocks -->
        <li class="flex flex-wrap" v-if="padlocks && padlocks.length" v-for="(option, index) in padlocks" :key="index">
            <div class="w-2/3" v-if="option">{{ option.value }}</div>
            <div class="w-1/3 text-right" v-if="!hidePrices && option">{{ price(option.price) }}</div>
        </li>

        <!-- Rimlocks -->
        <li class="flex flex-wrap" v-if="rimlocks && rimlocks.length" v-for="(option, index) in rimlocks" :key="index">
            <div class="w-2/3" v-if="option">{{ option.value }}</div>
            <div class="w-1/3 text-right" v-if="!hidePrices && option">{{ price(option.price) }}</div>

            <div v-if="option && option.rozet == 2" class="flex flex-wrap w-full">
                <div class="w-2/3 pl-4">+ Kerntrekrozet RVS</div>
                <div class="w-1/3 text-right" v-if="!hidePrices">
                    <span>
                        {{ price(39.5) }}
                    </span>
                </div>
            </div>
        </li>

        <!-- Discount cart -->
        <!-- <li v-if="discount && discount.length" class="flex flex-wrap text-green-600">
            <div class="w-2/3">Korting {{ cart.coupon ? ' - '+cart.coupon : ''  }}</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">
                <span class="font-semibold">-{{ priceEuro(discount[0].parsedRawValue * 1.21) }}</span>
            </div>
        </li> -->

        <!-- Discount productpage -->
        <li v-if="!hidePrices && totals && totals.discount" class="flex flex-wrap text-green-600">
            <div class="w-2/3">Korting {{ totals.discount.percentage }}%</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">
                <span class="font-semibold">-{{ priceEuro(totals.discount.value) }}</span>
            </div>
        </li>

        <!-- Extra Discount -->
        <li v-if="!hidePrices && totals && totals.extra_discount" class="flex flex-wrap text-green-600">
            <div class="w-2/3">Extra korting</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">
                <span class="font-semibold">-{{ priceEuro(totals.extra_discount) }}</span>
            </div>
        </li>

        <!-- Gelijksluitend -->
        <li class="flex flex-wrap" v-if="product && product.reorder_type != 2">
            <div class="w-2/3">Gelijksluitend geleverd</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">
                <span class="text-green-600 font-semibold"> Gratis </span>
            </div>
        </li>

        <!-- Verzending -->
        <li class="flex flex-wrap" v-if="product">
            <div class="w-2/3">Verzending</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">
                <span class="text-green-600 font-semibold"> Gratis </span>
            </div>
        </li>

        <!-- Sales -->
        <!-- <li v-if="$appStore.settings.sale_enabled" class="flex flex-wrap my-2">
        <li v-if="product && product.discount && product.discount.is_sale && $appStore.settings.sale_enabled" class="flex flex-wrap my-2">
            <div class="font-bold bg-black text-white rounded px-3 py-1 w-full mt-2 items-center flex shadow-red-700/20 shadow-overallxs border border-red-700">
                <fa :icon="['fas', 'fa-star']" class="h-3 w-3 mr-3 text-red-700" />
                <div class="grow">
                    {{ product.discount.title }}
                </div>
                <span class="text-right">- {{ product.discount.value }}%</span>
            </div>
        </li> -->

        <!-- Reference -->
        <li v-if="attributes.reference" class="flex flex-wrap">
            <div class="w-full">Referentie: <span class="font-extrabold">{{ attributes.reference }}</span></div>
        </li>

        <!-- Totaal -->
        <li v-if="totals && totals.discount && !hidePrices" class="flex flex-wrap">
            <div class="w-2/3">Totaal incl. BTW</div>
            <div class="w-1/3 text-right" v-if="!hidePrices">
                <s class="block">{{ price(totals.total + totals.discount.value) }}</s>
                <span class="font-extrabold text-lg">{{ priceEuro(totals.total) }}</span>
            </div>
        </li>

        <!-- Totaal -->
        <li v-else-if="totals && showTotal && !hidePrices" class="flex flex-wrap">
            <div class="w-1/2">Totaal incl. BTW</div>
            <div class="w-1/2 text-right">
                <span class="font-extrabold text-lg">{{
                    price((totals.total - (discount && discount.length ? discount[0].parsedRawValue * 1.21 : 0)) * (quantity ? quantity : 1))
                }}</span>
            </div>
        </li>
    </ul>
</template>

<script setup>
const props = defineProps({
    cylinders: Object,
    rimlocks: Object | Boolean,
    padlocks: Object | Boolean,
    totals: Object | Boolean,
    keys: Object | Boolean,
    keyQty: Number,
    options: Object,
    quantity: Number,
    product: Object | Boolean,
    discount: Array,
    sale: Boolean,
    mks: Boolean,
    hidePrices: Boolean,
    showTotal: {
        type: Boolean,
        default: true,
    },
    attributes: {
        type: Object,
        default: false,
        required: false,
    },
});
</script>
